import moment from "moment";

import store from "../store";
import { RepositoryFactory } from "../repositories/factory";

const UserAccountRepository = RepositoryFactory.get("user-account");
const ServiceAccountsRepository = RepositoryFactory.get("service-accounts");
const AsigProjectsRepository = RepositoryFactory.get("asig-projects");

export async function updateProfileState() {
  try {
    let userAccount = await store.getters["profile/userAccount"];
    if (!userAccount) {
      userAccount = await UserAccountRepository.get()
        .catch((err) => {
          // 発生したの内容を、エラー表示のデータに追加
          throw new Error(err);
        });
      // Storeの更新
      await store.dispatch("profile/updateProfile", userAccount);
    }
  } catch (err) {
    // TODO: 発生したエラーを画面に反映
    console.log(err);
  }
}

export async function updateServiceAccountState() {
  try {
    let serviceAccountList = await store.getters["service-account/serviceAccountList"];
    if (serviceAccountList.length === 0) {
      serviceAccountList = await ServiceAccountsRepository.index()
        .catch((err) => {
          // 発生したの内容を、エラー表示のデータに追加
          throw new Error(err);
        });
      // Storeの更新
      await store.dispatch("service-account/updateServiceAccountStatus", serviceAccountList);
    }
  } catch (err) {
    // TODO: 発生したエラーを画面に反映
    console.log(err);
  }
}

export async function currentServiceAccount() {
  const serviceAccount = await store.dispatch("service-account/getCurrentServiceAccount");
  return serviceAccount;
}

export async function getLastAccessDate() {
  const lastAccessDate = await store.dispatch("application/getLastAccessDate");
  return lastAccessDate;
}

export async function updateLastAccessDate() {
  await store.dispatch("application/updateLastAccessDate", moment());
}

export async function updateAsigProjectState(serviceAccountId) {
  try {
    let asigProjectList = await store.getters["asig-project/asigProjectList"];
    if (asigProjectList.length === 0) {
      asigProjectList = await AsigProjectsRepository.index(serviceAccountId)
        .catch((err) => {
          // 発生したの内容を、エラー表示のデータに追加
          throw new Error(err);
        });
      // Storeの更新
      await store.dispatch("asig-project/updateAsigProjectStatus", asigProjectList);
    }
  } catch (err) {
    // TODO: 発生したエラーを画面に反映
    console.log(err);
  }
}

// ナビゲーション通知の初期化
export async function restNavbarNotification() {
  await store.dispatch("notification/resetState");
}
